(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function createSvgElement(name, attributes = {}) {
    const node = document.createElementNS('http://www.w3.org/2000/svg', name);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, String(value)));
    return node;
  }

  function renderCashChart(root) {
    const svg = root.querySelector('[data-cash-chart]');
    if (!svg || svg.dataset.rendered === 'true') return;

    const values = (svg.dataset.values || '')
      .split(',')
      .map((value) => Number(value.trim()))
      .filter(Number.isFinite);
    if (values.length < 2) return;

    const width = 900;
    const height = 360;
    const left = 52;
    const right = 18;
    const top = 20;
    const bottom = 42;
    const usableWidth = width - left - right;
    const usableHeight = height - top - bottom;
    const maximum = Math.ceil(Math.max(...values) / 5000) * 5000;
    const point = (value, index) => ({
      x: left + (index / (values.length - 1)) * usableWidth,
      y: top + usableHeight - (value / maximum) * usableHeight,
    });
    const points = values.map(point);

    svg.setAttribute('viewBox', `0 0 ${width} ${height}`);

    for (let i = 0; i <= 5; i += 1) {
      const y = top + (usableHeight / 5) * i;
      const value = maximum - (maximum / 5) * i;
      svg.appendChild(createSvgElement('line', {
        x1: left,
        x2: width - right,
        y1: y,
        y2: y,
        class: 'wp-cash-grid',
      }));
      const label = createSvgElement('text', { x: 0, y: y + 4 });
      label.textContent = value === 0 ? '€0' : `€${Math.round(value / 1000)}k`;
      svg.appendChild(label);
    }

    const areaPoints = [
      `${left},${top + usableHeight}`,
      ...points.map(({ x, y }) => `${x},${y}`),
      `${width - right},${top + usableHeight}`,
    ].join(' ');
    svg.appendChild(createSvgElement('polygon', { points: areaPoints, class: 'wp-cash-fill' }));
    svg.appendChild(createSvgElement('polyline', {
      points: points.map(({ x, y }) => `${x},${y}`).join(' '),
      class: 'wp-cash-line',
    }));

    [0, 11, 23, 35].forEach((index) => {
      const { x, y } = points[index];
      const dot = createSvgElement('circle', {
        cx: x,
        cy: y,
        r: 5,
        class: 'wp-cash-dot',
        tabindex: 0,
        role: 'img',
        'aria-label': `${index === 0 ? 'January 2027' : index === 11 ? 'December 2027' : index === 23 ? 'December 2028' : 'December 2029'} end cash €${values[index].toLocaleString('en-US')}`,
      });
      svg.appendChild(dot);
    });

    [
      { x: left, text: 'Jan 2027', anchor: 'start' },
      { x: points[11].x, text: 'Dec 2027', anchor: 'middle' },
      { x: points[23].x, text: 'Dec 2028', anchor: 'middle' },
      { x: width - right, text: 'Dec 2029', anchor: 'end' },
    ].forEach(({ x, text, anchor }) => {
      const label = createSvgElement('text', {
        x,
        y: height - 8,
        'text-anchor': anchor,
      });
      label.textContent = text;
      svg.appendChild(label);
    });

    svg.dataset.rendered = 'true';
  }

  function initialise(root) {
    if (root.dataset.initialised === 'true') return;
    root.dataset.initialised = 'true';

    const progress = root.querySelector('[data-plan-progress]');
    const backTop = root.querySelector('[data-back-top]');
    const updateScrollState = () => {
      const bounds = root.getBoundingClientRect();
      const total = Math.max(root.scrollHeight - window.innerHeight, 1);
      const travelled = Math.min(Math.max(-bounds.top, 0), total);
      if (progress) progress.style.transform = `scaleX(${travelled / total})`;
      if (backTop) backTop.classList.toggle('is-visible', travelled > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', updateScrollState, { passive: true });
    window.addEventListener('resize', updateScrollState, { passive: true });
    updateScrollState();

    if (backTop) {
      backTop.addEventListener('click', () => {
        root.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    }

    const jump = root.querySelector('[data-section-jump]');
    if (jump) {
      jump.addEventListener('change', () => {
        const target = root.querySelector(jump.value);
        if (target) target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    }

    const sections = [...root.querySelectorAll('[data-plan-section]')];
    const navLinks = [...root.querySelectorAll('[data-plan-nav]')];
    if ('IntersectionObserver' in window && sections.length) {
      const observer = new IntersectionObserver((entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        navLinks.forEach((link) => {
          link.setAttribute('aria-current', String(link.getAttribute('href') === `#${visible.target.id}`));
        });
      }, { rootMargin: '-25% 0px -60% 0px', threshold: [0, 0.2, 0.5] });
      sections.forEach((section) => observer.observe(section));
    }

    const riskButtons = [...root.querySelectorAll('[data-risk-filter]')];
    const risks = [...root.querySelectorAll('[data-risk]')];
    riskButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.riskFilter;
        riskButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
        risks.forEach((risk) => {
          risk.hidden = filter !== 'all' && risk.dataset.level !== filter;
        });
      });
    });

    renderCashChart(root);
  }

  const boot = () => document.querySelectorAll('[data-waifed-plan]').forEach(initialise);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-waifed-plan]');
    if (root) initialise(root);
  });
})();
